type Props = {
  size?: number;
};

// Chrome rasterises SVG elements at their display size, then applies CSS
// transforms during compositing — discarding the extra resolution. Rendering at
// 2× and scaling back forces a higher-resolution raster for smoother edges.
// `will-change: transform` ensures Chrome allocates a dedicated GPU layer.
const SUPERSAMPLE = 2;

export const VectaIcon = ({ size = 34 }: Props) => {
  const w = size;
  const h = Math.round(size * (36 / 32));
  return (
  <svg
    width={w * SUPERSAMPLE}
    height={h * SUPERSAMPLE}
    viewBox="0 0 32 36"
    fill="none"
    style={{
      transform: `scale(${1 / SUPERSAMPLE})`,
      transformOrigin: "top left",
      marginRight: -(w * (SUPERSAMPLE - 1)),
      marginBottom: -(h * (SUPERSAMPLE - 1)),
      willChange: "transform",
    }}
  >
    <polygon points="1,4 31,4 16,13" fill="#ECEEF2" />
    <polygon points="1,4 16,13 16,34" fill="#8C919E" />
    <polygon points="31,4 16,13 16,34" fill="#C6CAD4" />
  </svg>
  );
};
